import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Breadcrumb } from "ant-design-vue";
import { Paths } from "@/util/paths";
import { GLUtil } from "commonui";
import { AppBreadCrumbModule } from "@/modules/bread-crumb";
import { isEmpty } from "lodash";

@Component({
	components: {
		Breadcrumb
	}
})
export default class AppBreadcrumb extends Vue {
	public basePath = Paths.Dashborad;
	public state = AppBreadCrumbModule;
	public routes = this.state.routes;
	public breadcrumbSeparator = "";

	@Watch("state.routes")
	resetRoutes() {
		this.routes = this.state.routes;
	}

	formPath(route) {
		if (!isEmpty(route.params) && !isEmpty(route.queryParams)) {
			const path = GLUtil.pathStringify(route.path, {
				...route.params
			});
			const queryParamString = GLUtil.queryStringify(route.queryParams);
			return queryParamString ? `${path}?${queryParamString}` : path;
		} else if (!isEmpty(route.params)) {
			return GLUtil.pathStringify(route.path, {
				...route.params
			});
		} else {
			return GLUtil.pathStringify(route.path, {});
		}
	}
}
